import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import icoback from './img/ico-back.svg';
import icobackblue from './img/ico-backblue.svg';
import icosearch from './img/ico-search.svg';
import icoclose from './img/ico-close.svg';
import strings from './strings.js'
import SongCard from './SongCard';
import SelectingYesNoCard from './SelectingYesNoCard';
import heart from './img/heart.svg';
import noheart from './img/noheart.svg';
import { SendMessage } from './App.js';
import useSingerSpecificSearch from './useSingerSpecificSearch';

const API_URL = "https://www.starboxkod.com/api";

const song1 = {
    "song_num": 110108,
    "song_name": "给我多一点",
    "singer": "SHE",
    "language": "国语",
    "server_id": "C",
    "rel_path": "05\\110108"
}


const SelectingYesNoSinger = ({ cookieFavs, setCookieFavs, song, onClick, stateVer, selectingYesNo, tableNo, lang, footerDisabled} ) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [pageNumber, setPageNumber] = useState(0);
    const [searchLang, setSearchLang] = useState(song);

    const [blockedSongs, setBlockedSongs] = useState(() => {
        const item = localStorage.getItem("black");
        if (!item) return []; // Fallback if key doesn't exist
        
        const parsed = JSON.parse(item);
        return parsed?.song_num ?? [];
    });
        const LANGUAGE_MAP = {
    2: "国语",
    7: "粤语",
    5: "台语",
    15: "潮语",
    6: "英语",
    9: "马来",
    4: "日语",
    3: "韩语",
    10: "泰语",
    13: "印度语",
    12: "越南语",
    14: "菲律宾语"
    };

    const [blockedLangs, setBlockedLangs] = useState(() => {
        const item = localStorage.getItem("black");
        if (!item) return [];

        try {
            const parsed = JSON.parse(item);
            const langIds = parsed?.language ?? [];

            // Map each ID to its language name; fall back to the ID string if missing
            return langIds.map(id => LANGUAGE_MAP[id] ?? String(id));
        } catch (error) {
            console.error("Failed to parse local storage key 'black'", error);
            return [];
        }
    });

    const {
        loading,
        error,
        songs,
        hasMore
    } = useSingerSpecificSearch(searchTerm, pageNumber, searchLang, blockedSongs, blockedLangs)

    const observer = useRef()
    const lastSongElementRef = useCallback(node => {
        if (loading) return
        if (observer.current) observer.current.disconnect()
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                setPageNumber(prevPageNumber => prevPageNumber + 20)
            }
        })
        if (node) observer.current.observe(node)
    }, [loading, hasMore])
    
    function handleSearch(e) {
        setSearchTerm(e.target.value)
        setPageNumber(0)
    }
    
    useEffect(() => {
        setPageNumber(0)
        document.getElementById("song-container").scrollTop =0;
      }, [searchTerm, searchLang])


    const [selectingYesNoSong, setSelectingYesNoSong] = useState({});
    function nowSelectSong ({ song }) {
        navigate("/home/artists/singer/select");
        //check if it's empty, if so then intialise
        setSelectingYesNoSong(song);
    }
   
    const navigate = useNavigate()
    
    return (<>
    <div className="artistSpecific">
    <div className="heatder" style={{zIndex:12}}>
        <a onClick={(e) => {e.preventDefault(); onClick()}}>
        <img
            src={icoback}
            alt="home"
        />
        </a>
        <div className = "headersearch">
            <img className = "headersearchIcon"
                src={icosearch}
                alt="search"
            />
            <input
                placeholder={lang ? strings.cn.search : strings.en.search}
                value={searchTerm}
                onChange={handleSearch}
            />
            <a onClick={(e) => {e.preventDefault(); setSearchTerm("");}}>
            <img className = "headersearchClose"
                src={icoclose}
                alt="search"
            />
            </a>
        </div>

    </div>
    
    <div className='purpleHeader26'>
    <div className ="headerBelow">{song}</div>
    <div className="language-bar-container">
        <div className="language-bar"></div>
        </div>
    
</div>
    <div className="song-container" id="song-container" style={{ marginBottom: footerDisabled ? "-55px" : ""}}>
    {songs?.length > 0
        ? (
            <>
                {songs.map((song, index) => {
                    if (songs.length == index + 1) {
                        return <SongCard innerRef={lastSongElementRef} song={song} key={song.song_num} lang={lang} onClick={() => { nowSelectSong({song});}}/>
                    } else {
                        return <SongCard song={song} key={song.song_num} lang={lang} onClick={() => { nowSelectSong({song});}}/>
                    }
                    
                })}     
            </>
        ) :
        (
            <div className="empty">
                <h2>No songs found</h2>
            </div>
        )}
    </div>
    {loading && 'Loading...'}
    {error && 'Error...'}

    { selectingYesNo && (
        <>
        <SelectingYesNoCard cookieFavs={cookieFavs} setCookieFavs={setCookieFavs} song={selectingYesNoSong} stateVer={stateVer} lang={lang} onClick={() => { navigate(-1)}} tableNo={tableNo}/>
        </>
    )}
    </div>
</>

    );
}

export default SelectingYesNoSinger;